import type { DatepickerRange, MultiselectItem, TableListItem } from '@ui/aos-lib';
import type { AlarmStatisticResponse } from '../../alarms/services/alarms.types';
import type {
  BatteryStatistic,
  HealthMonitorFilter,
  HealthMonitorFilterType,
  HealthStatistic,
  ReadRateStatistic,
  ReadSuccessRateStatistic
} from '../health-monitor.types';
import { initialRequestStatusState, RequestStatusState } from '@portal/shared/store/request-status';
import { FilterModel } from '../../../../shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { HealthFilterName } from '../health-api.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { calculateReadRateStatistic } from './mappers/read-rate.mappers';
import { createHealthStatistic } from './mappers/overall-health.mappers';

export interface HealthFilterModel extends FilterModel {
  defaultItems: MultiselectItem[];
}

export type HealthMonitorState = {
  healthMonitorFilters: HealthFilterModel[];
  deviceTypesFilters: readonly HealthMonitorFilter[];
  filtersCountRequest: RequestStatusState;
  selectedDevicesFilters: readonly HealthMonitorFilterType[];
  readRateStatistic: ReadRateStatistic;
  readRateStatisticRequest: RequestStatusState;
  readSuccessRateStatistic: ReadSuccessRateStatistic;
  readSuccessRateStatisticRequest: RequestStatusState;
  batteryStatistic: BatteryStatistic;
  batteryDevicesIsNotEmpty: boolean;
  batteryStatisticRequest: RequestStatusState;
  healthStatuses: HealthStatistic;
  healthStatusesRequest: RequestStatusState;
  historyLog: TableListItem[];
  historyLogRequest: RequestStatusState;
  alarmStatistics: AlarmStatisticResponse;
  alarmStatisticsRequest: RequestStatusState;
  filtersAndInitFiltersStateRequest: RequestStatusState;
  alarmsDateRange: DatepickerRange | null;
  historyLogDateRange: DatepickerRange | null;
};

// TODO: Actualize the keys. Rename `mtu' to 'Metering'. Specify the type of the keys.
export const initialDeviceTypesFilters: readonly HealthMonitorFilter[] = [
  { count: 0, label: TranslateRegistry.get.FILTER.TITLE.METERING, iconName: 'mtu', type: 'mtu' },
  { count: 0, label: TranslateRegistry.get.FILTER.TITLE.DCUS_BASE_STATIONS, iconName: 'dcu', type: 'dcu' },
  { count: 0, label: TranslateRegistry.get.FILTER.TITLE.SENSORS, iconName: 'exactaguard', type: 'sensors' }
];

export const initialReadRateStatistic: ReadRateStatistic = {
  ...calculateReadRateStatistic({
    transmissionReadRateCount: [],
    validTransmissionReadRateCount: []
  })
};

export const initialReadSuccessRateStatistic: ReadSuccessRateStatistic = {
  readSuccessRate24Hours: null,
  readSuccessRate72Hours: null
};

export const initialBatteryStatistic: BatteryStatistic = {};

export const initialHealthStatuses: HealthStatistic = createHealthStatistic([]);

export const initialAlarmStatistics: AlarmStatisticResponse = {
  alarmsDevicesSeverityCount: [],
  alarmsGroupCount: []
};

const reportGroupFilter: HealthFilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.REPORT_GROUP,
  items: [],
  selected: [],
  filterType: HealthFilterName.ReportGroup,
  defaultItems: [],
  isMultiselect: true,
  hasSearch: true,
  width: 10
};

export const initialState: HealthMonitorState = {
  healthMonitorFilters: [reportGroupFilter],
  deviceTypesFilters: initialDeviceTypesFilters,
  filtersCountRequest: initialRequestStatusState,
  selectedDevicesFilters: [],
  readRateStatistic: initialReadRateStatistic,
  readRateStatisticRequest: initialRequestStatusState,
  readSuccessRateStatistic: initialReadSuccessRateStatistic,
  readSuccessRateStatisticRequest: initialRequestStatusState,
  batteryStatistic: initialBatteryStatistic,
  batteryDevicesIsNotEmpty: false,
  batteryStatisticRequest: initialRequestStatusState,
  healthStatuses: initialHealthStatuses,
  healthStatusesRequest: initialRequestStatusState,
  historyLog: [],
  historyLogRequest: initialRequestStatusState,
  alarmStatistics: initialAlarmStatistics,
  alarmStatisticsRequest: initialRequestStatusState,
  filtersAndInitFiltersStateRequest: initialRequestStatusState,
  alarmsDateRange: null,
  historyLogDateRange: null
};
